import React, { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './MapPicker.css';

// Fix for default marker icons in react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

function MapUpdater({ center, zoom }) {
  const map = useMap();
  
  useEffect(() => {
    if (center && zoom) {
      map.setView(center, zoom);
    }
  }, [map, center, zoom]);
  
  return null;
}

function DraggableMarker({ position, onPositionChange }) {
  const markerRef = useRef(null);

  useEffect(() => {
    const marker = markerRef.current;
    if (marker) {
      marker.on('dragend', () => {
        const newPos = marker.getLatLng();
        onPositionChange({ lat: newPos.lat, lng: newPos.lng });
      });
    }
  }, [onPositionChange]);

  return <Marker position={position} draggable={true} ref={markerRef} />;
}

function MapClickHandler({ onMapClick }) {
  useMapEvents({
    click: (e) => {
      onMapClick({ lat: e.latlng.lat, lng: e.latlng.lng });
    },
  });
  return null;
}

const MapPicker = ({ latitude, longitude, onLocationChange, height = '400px' }) => {
  const defaultCenter = [51.5074, -0.1278]; // London as default
  const center = latitude && longitude ? [latitude, longitude] : defaultCenter;
  const zoom = latitude && longitude ? 17 : 6;

  const handlePositionChange = (newPos) => {
    if (onLocationChange) {
      onLocationChange(newPos.lat, newPos.lng);
    }
  };

  return (
    <div className="map-picker" style={{ height }}>
      <MapContainer
        center={center}
        zoom={zoom}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MapUpdater center={center} zoom={zoom} />
        <MapClickHandler onMapClick={handlePositionChange} />
        {latitude && longitude && (
          <DraggableMarker
            position={center}
            onPositionChange={handlePositionChange}
          />
        )}
      </MapContainer>
      <p className="map-helper-text">
        {latitude && longitude
          ? 'Drag the marker or click on the map to change the location'
          : 'Click on the map to set your farm location'}
      </p>
    </div>
  );
};

export default MapPicker;
